'use client'

// Tabs (the design system's .tabs): a hairline under the row, the active
// tab underlined 2 px in the primary colour, an optional count badge.
export type TabDef<T extends string> = { value: T; label: React.ReactNode; count?: number }

export function Tabs<T extends string>({ tabs, value, onChange, end, className = '' }: { tabs: TabDef<T>[]; value: T; onChange: (v: T) => void; end?: React.ReactNode; className?: string }) {
  return (
    <div className={`flex items-center justify-between border-b border-border ${className}`}>
      <div role="tablist" className="flex gap-6">
        {tabs.map((t) => {
          const on = t.value === value
          return (
            <button
              key={t.value}
              type="button"
              role="tab"
              aria-selected={on}
              onClick={() => onChange(t.value)}
              className={`-mb-px flex h-[43px] items-center gap-2 border-b-2 pb-3 text-nav transition-colors ${on ? 'border-primary font-semibold text-foreground' : 'border-transparent font-[450] text-muted-foreground hover:text-foreground'}`}
            >
              {t.label}
              {t.count != null && <span className={`rounded-[4px] px-[5px] py-[1px] font-mono text-micro ${on ? 'bg-accent text-primary' : 'bg-secondary text-subtle'}`}>{t.count}</span>}
            </button>
          )
        })}
      </div>
      {end}
    </div>
  )
}
